import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ReactTooltip from 'react-tooltip';

import RadioFieldSet from 'components/ui/RadioFieldSet';
import CustomRadioField from 'components/ui/CustomRadioField';
import { PAX_DESCRIPTIONS } from 'constants/booking';

import {
  ErrorMessageContainer,
  StyledStandardPassengerSelection,
  RadioFieldsContainer,
  StyledDescription,
  InfoIcon,
  TooltipContent
} from './StandardPassengerSelection.styles';

export const passengersRadioButtons = [
  { label: '0', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' }
];

const paxTypes = ['adults', 'seniors', 'children', 'youths'];
const paxTypesSNCB = ['adults', 'youths', 'seniors', 'children'];

const StandardPassengerSelection = ({
  passengers,
  onChangePassengers,
  passengerRangeError,
  containSNCBDBOrNSStation,
  infantsOnLapEnabled,
  maxInfants = 0
}) => {
  const passengersOrder = containSNCBDBOrNSStation ? paxTypesSNCB : paxTypes;
  return (
    <StyledStandardPassengerSelection>
      {passengersOrder.map((passengerType) => {
        const multipleSeniors = containSNCBDBOrNSStation && passengerType === 'seniors';
        return multipleSeniors ? (
          ['seniors60To64', 'seniors65Plus'].map((seniorType) => (
            <RadioFieldsContainer key={seniorType}>
              <RadioFieldSet
                name={seniorType}
                spaceBetween
                legend={
                  <>
                    <FormattedMessage id={`bookingMagnet.${passengerType}`} />{' '}
                    <StyledDescription>
                      (
                      <FormattedMessage id={`groupBooking.${PAX_DESCRIPTIONS[seniorType]}`} />)
                    </StyledDescription>
                  </>
                }
                radioButtons={passengersRadioButtons}
                selectedValue={(passengers[seniorType] || '').toString()}
                onChange={({ target: { value } }) => {
                  const amountByPassengerType = {
                    [seniorType]: parseInt(value, 10)
                  };

                  onChangePassengers(amountByPassengerType);
                }}
                CustomRadioField={CustomRadioField}
              />
            </RadioFieldsContainer>
          ))
        ) : (
          <RadioFieldsContainer key={passengerType}>
            <RadioFieldSet
              name={passengerType}
              spaceBetween
              legend={
                <>
                  <FormattedMessage id={`bookingMagnet.${passengerType}`} />{' '}
                  <StyledDescription>
                    (
                    <FormattedMessage id={`groupBooking.${PAX_DESCRIPTIONS[passengerType]}`} />)
                  </StyledDescription>
                </>
              }
              radioButtons={passengersRadioButtons}
              selectedValue={(passengers[passengerType] || '').toString()}
              onChange={({ target: { value } }) => {
                const amountByPassengerType = {
                  [passengerType]: parseInt(value, 10)
                };

                onChangePassengers(amountByPassengerType);
              }}
              CustomRadioField={CustomRadioField}
            />
          </RadioFieldsContainer>
        );
      })}
      {infantsOnLapEnabled && (
        <RadioFieldsContainer>
          <RadioFieldSet
            name="infants"
            legend={
              <>
                <FormattedMessage id="bookingMagnet.infantsOnLap" />{' '}
                <StyledDescription>
                  (<FormattedMessage id="bookingMagnet.infantsOnLapDescription" />)
                </StyledDescription>{' '}
                <InfoIcon data-tip data-for="infants-on-lap-tooltip">
                  &#9432;
                </InfoIcon>
                <ReactTooltip id="infants-on-lap-tooltip" place="right" effect="solid">
                  <TooltipContent>
                    <FormattedMessage id="bookingMagnet.infantsOnLapTooltip" />
                  </TooltipContent>
                </ReactTooltip>
              </>
            }
            radioButtons={passengersRadioButtons.slice(0, maxInfants + 1)}
            selectedValue={(passengers.infants || 0).toString()}
            onChange={({ target: { value } }) => {
              onChangePassengers({ infants: parseInt(value, 10) });
            }}
            CustomRadioField={CustomRadioField}
          />
        </RadioFieldsContainer>
      )}
      <ErrorMessageContainer>{passengerRangeError && <FormattedMessage id={passengerRangeError} />}</ErrorMessageContainer>
    </StyledStandardPassengerSelection>
  );
};

StandardPassengerSelection.propTypes = {
  passengers: PropTypes.shape(),
  onChangePassengers: PropTypes.func.isRequired,
  passengerRangeError: PropTypes.string,
  containSNCBDBOrNSStation: PropTypes.bool,
  infantsOnLapEnabled: PropTypes.bool,
  maxInfants: PropTypes.number
};

export default StandardPassengerSelection;
